import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PropostasService } from '@app/api/propostas/proposta.service';
import { catchError, map, of } from 'rxjs';

export const DecodeLinkGuard = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const propostaService = inject(PropostasService);
  const token = route.params['token'];

  if (!token) {
    return of(
      router.createUrlTree(['/'], {
        queryParams: { message: 'Não foi possível validar o link informado.' },
      })
    );
  }

  return propostaService.decodeLink(token).pipe(
    map((response: any) => {
      const codigoOrganizacao = String(response?.data?.CodigoOrganizacao || '');
      const routerOrganizacao = String(response?.data?.Router || '').trim();
      const codigoProposta = Number(response?.data?.CodigoProposta);
      const organizacaoPath = routerOrganizacao || codigoOrganizacao;

      if (!organizacaoPath || !codigoProposta || Number.isNaN(codigoProposta)) {
        return router.createUrlTree(['/'], {
          queryParams: { message: 'Não foi possível validar o link informado.' },
        });
      }

      return router.createUrlTree([`/${organizacaoPath}/auth/sign-in`], {
        queryParams: {
          returnUrl: `/${organizacaoPath}/proposta/${codigoProposta}/nova-proposta`,
        },
      });
    }),
    catchError(() =>
      of(
        router.createUrlTree(['/'], {
          queryParams: { message: 'Não foi possível validar o link informado.' },
        })
      )
    )
  );
};
